<template>
  <div id="app">
    <div id="top">
      <div id="top_cont">
        <div id="top_cont_name">
          <img width="100%" height="22px" :src="imgSiteNum0" />
        </div>
        <div id="top_cont_nav">
          <nav>
            <ul class="outs_ul">
              <li>
                <router-link class="one" to="/" exact>
                  <p>{{ testList[0] }}</p>
                  <i class="henxian"></i>
                </router-link>
              </li>
              <li>
                <a class="one" :style="{ color: wordColor }">
                  <p>{{ testList[1] }}</p>
                  <i
                    class="henxian"
                    :style="{ 'background-color': backgroundColor }"
                  ></i>
                </a>
                <ul class="chanp_ul">
                  <li>
                    <router-link to="/halababy" class="one_chanp" exact
                      >{{ testList[2] }}</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/looplay" class="one_chanp" exact>{{ testList[3] }}</router-link>
                  </li>
                  <li>
                    <router-link to="/uoofox" class="one_chanp" exact>{{ testList[14] }}</router-link>
                  </li>
                </ul>
              </li>
              <li>
                <router-link class="one" to="/brand" exact>
                  <p>{{ testList[4] }}</p>
                  <i class="henxian"></i>
                </router-link>
              </li>
              <li>
                <router-link class="one" to="/about" exact>
                  <p>{{ testList[5] }}</p>
                  <i class="henxian"></i>
                </router-link>
              </li>
              <li>
                <a class="word">
                  <p>{{ wordCon }}</p>
                  <i class="henxian"></i>
                </a>
                <ul>
                  <li>
                    <a class="one_yuy" @click="changeWord('zh')">简体中文</a>
                  </li>
                  <li>
                    <a class="one_yuy" @click="changeWord('en')">English</a>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
        </div>
        <div id="top_cont_search">
          <input
            type="text"
            class="input"
            id="topInput"
            v-model="topSearchValue"
            :placeholder="testList[6]"
            @keyup.enter="topSearch()"
          />
          <i @click="topSearch()"></i>
        </div>
      </div>
    </div>
    <div id="content">
      <router-view :langType="langType"> </router-view>
    </div>
    <div id="bottom">
      <div class="bto1">
        <div class="bto11">
          <router-link to="/" exact>{{ testList[0] }}</router-link>
        </div>
        <div class="bto11">
          <router-link to="/looplay" class="one_chanp" exact>{{testList[1]}}</router-link>
        </div>
        <div class="bto11">
          <router-link to="/#" exact>{{ testList[7] }}</router-link>
          </div>
        <!-- <div class="bto11">
          <router-link to="/brand" exact>{{ siteNum4 }}</router-link>
        </div> -->
        <div class="bto11">
          <router-link to="/about" exact>{{ testList[5] }}</router-link>
        </div>
        <div class="bto11">
          <router-link to="/#" exact class="halababy_app_1">{{ testList[8] }}</router-link>
        </div>
      </div>
      <div class="bto2"></div>
      <div class="bto1">
        <div class="halababy_app_3">
        </div>
        <div class="halababy_app_3">
          <router-link to="/halababy" exact>{{ testList[2] }}</router-link>
          <router-link to="/looplay" exact>{{ testList[3] }}</router-link>
          <router-link to="/uoofox" exact>Uoofox</router-link>
        </div>
        <div class="halababy_app_3">
          <span title="正在建设中，请耐心等待">开发者</span>
          <router-link to="/spreader/login" exact>推广者</router-link>
        </div>
        <div class="halababy_app_3">
          <router-link to="/wx/leaveWords" exact>留言反馈</router-link>
        </div>
        <div class="halababy_app_3">
          <router-link to="/privacyPolicy" exact>{{ testList[9] }}</router-link>
          <router-link to="/protocol" exact>{{ testList[10] }}</router-link>
          <router-link to="/copyright" exact>{{ testList[11] }}</router-link>
        </div>
      </div>
      <div class="bto2"></div>
      <div class="halababy_app_4">
        <p> Copyright 2019 - 2029 | All Rights Reserved IOOFOX 深圳市云方程数据技术有限公司 | <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022061985号</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Website",
  created() {
    
    this.$nextTick(() => {
      // 在此处执行你要执行的函数
      this.updateProductChange();
    });
  },
  mounted: function () {
    // this.wordCon = "简体中文";
    this.getImg();
    var lan = navigator.language;
    if(lan == 'zh-CN'){
      this.getText('zh')
      this.wordCon = "简体中文";
    }else{
      this.getText('en')
      this.wordCon = "English";
    }
    // this.getText(this.$i18n.locale);
  },
  methods: {
    topSearch() {
      this.$router.push({
        name: "search",
        params: { content: this.topSearchValue },
      });
    },
    getImg() {
      this.$post("/halababy/loofox/img", { pageNum: 6 }).then((res) => {
        this.imgSiteNum0 = this.$ip + res.data[0]["imgUrl"];
      });
    },
    //选择语言
    changeWord(type) {
      // 此处做了语言选择记录
      localStorage.setItem("locale", type);
      // 修改显示语言
      this.$i18n.locale = type;
      this.langType = type;
      if (type == "zh") {
        this.wordCon = "简体中文";
      } else {
        this.wordCon = "English";
      }
      this.getText(type);
    },
    //更新"产品介绍"的样式变化
    updateProductChange() {
      let currentUrlPath = this.$route.path;
      if (currentUrlPath == "/halababy" || currentUrlPath == "/looplay") {
        this.wordColor = "rgba(10, 177, 255, 1)";
        this.backgroundColor = "rgba(10, 177, 255, 1)";
      } else {
        this.wordColor = "#000000";
        this.backgroundColor = "";
      }
    },
    //获取文本
    getText(type) {
      this.$post("/halababy/loofox/text", { pageNum: 6 }).then((res) => {

        if (type == "zh") {
          let arr = new Array();
          for(var index in res.data){
            arr.push(res.data[index]["content"]);
          }
          this.testList = arr;
        } else {
          let arr = new Array();
          for(var index in res.data){
            arr.push(res.data[index]["contentEn"]);
          }
          this.testList = arr;
        }
      });
    },
  },
  updated: function () {
    this.updateProductChange();
  },
  data() {
    return {
      wordCon: this.wordCon,
      wordColor: this.wordColor,
      backgroundColor: this.backgroundColor,
      topSearchValue: "",
      testList:[],
      langType: this.langType,
      imgSiteNum0: this.imgSiteNum0,
    };
  },
};
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  min-width: 1260px;
}

ul,
p {
  margin: 0;
  padding: 0;
}
#top {
  width: 100%;
  height: 72px;
  align-items: center;
}
#top_cont {
  width: 1200px;
  height: 72px;
  margin: auto;
  display: flex;
}
#top_cont_name {
  width: 15%;
  height: 72px;
  display: flex;
  align-items: center;
}
#top_cont_nav {
  margin-left: 20%;
  width: 50%;
  height: 72px;
}
#top_cont_search {
  display: flex;
  flex-direction: row;
  width: 15%;
  height: 72px;
  align-items: center;
}
#top_cont_search input {
  width: 130px;
  height: 20px;
  outline: none;
  border: 0;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0);
}
#top_cont_search i {
  display: block;
  width: 18px;
  height: 18px;
  background: url("../assets/search.png") no-repeat;
  background-size: 18px 18px;
  cursor: pointer;
}

#bottom {
  width: 100%;
  /* height: 140px; */
  background-color: rgb(0, 0, 0);
  display: flex;
  flex-direction: column;
}
.bto1 {
  /* width: 1200px; */
  /* height: 93px; */
  margin: auto;
  display: flex;
  justify-self: start;
}
.bto11 {
  width: 200px;
}
.bto11 a {
  color: #ffffff;
  text-decoration: none;
  
  /* height: 93px; */
  line-height: 50px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.bto2 {
  width: 100%;
  height: 1px;
  background: #ffffff;
  opacity: 0.3;
}

nav {
  width: 100%;
  height: 72px;
}
nav .outs_ul {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
}

nav ul li {
  list-style: none;
  position: relative;
  width: 100px;
}

nav ul li i {
  display: block;
  margin: auto;
  width: 30%;
  height: 2px;
}

nav ul li:hover i {
  background-color: rgba(10, 177, 255, 1);
}

.one {
  cursor: pointer;
}
nav ul li:hover .one {
  color: rgba(10, 177, 255, 1);
}

nav ul li a {
  display: block;
  font-family: arial;
  font-size: 14px;
  padding: 18px 10px;
  text-decoration: none;
  color: #000000;
}

nav ul li a p {
  padding: 8px 0;
}

nav ul li ul {
  /* display: none; */
  position: absolute;
  z-index: -10;
  background-color: #fff;
  top: 60px;
}

nav ul li:hover ul {
  /* display: block; */
  z-index: 10;
}

nav ul li ul li {
  /* display: block; */
}

nav ul li ul li a {
  display: block;
  font-family: arial;
  font-size: 14px;
  padding: 10px 10px;
  text-decoration: none;
}

nav ul li ul li a:hover {
  color: rgba(10, 177, 255, 1);
}

/* 点击后添加的样式 */
.one.router-link-active {
  color: rgba(10, 177, 255, 1);
}
.one.router-link-active .henxian {
  background-color: rgba(10, 177, 255, 1);
}
.one_chanp.router-link-active {
  color: rgba(10, 177, 255, 1);
}
.one_yuy {
  cursor: pointer;
}
.word {
  cursor: pointer;
}
.halababy_app_ul{
  margin: 0px;
  border: 0px;
}

.halababy_app_ul li{
  list-style: none;
  line-height: 50px;
}
/* .halababy_app_1{
  border-bottom: 1px solid #ffffff ;
} */
.halababy_app_2{
  width: 200px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
/* .halababy_app_2:hover .halababy_app_ul{
  display: block;
} */
.halababy_app_3{
  width: 200px;
}
.halababy_app_3 a{
  color: #929292;
  text-decoration: none;
  line-height: 50px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  display: block;
}
.halababy_app_3 span{
  color: #929292;
  text-decoration: none;
  line-height: 50px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  display: block;
}
.halababy_app_4{
  display: table-cell;
  height: 80px;
  line-height: 80px;
  color: #ffffff;
  font-size: 10px;
}
.halababy_app_4 a{
  text-decoration: none;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/website.vue